import React from 'react';
import gradientCircle from '../assets/images/gradient-circle.svg';
import gradientBlue from '../assets/images/gradient blue circle.svg';

const testimonials = [
  {
    text: '"DDevOps is easily one of the best hosting solution providers we have worked with. Their support is exceptional—quick to respond and incredibly professional. We have hardly faced any issues since partnering with them. Their approach to handling any request is second to none, and we recommend them highly."',
    company: '— Fakieheats',
    author: 'Zohaib Ahmed – Vantage Digital',
  },
  {
    text: '"After struggling for years with our infrastructure, partnering with DDevOps was a turning point. They manage our servers and IT like an extension of our own team—it feels like family. They impressively anticipate exactly what we need, right when we need it. We are thoroughly impressed with their proactive service."',
    company: '— GOPROT SARL',
    author: 'Muhammad Talha – CTO',
  },
  {
    text: '"We faced serious instability with our previous host, but moving to DDevOps completely stabilized our website. They are a top-tier provider with hugely satisfying services and outstanding support. We are extremely happy with the results and highly recommend DDevOps to anyone needing a truly reliable hosting partner."',
    company: '— Blue Ocean Restaurant',
    author: 'Zohaib Ahmed – Manager',
  },
  {
    text: '"Frustrated with my previous provider and needing strong technical support, I was thankfully referred to DDevOps. Their competitive pricing, robust solutions, and deep technical expertise convinced me to switch. My expectations have been fully met; I am one of their happiest customers and highly recommend their team."',
    company: '— Design Intellect',
    author: 'Behlool Fakhruddin – Founder',
  },
  {
    text: '"Running a complex consumer internet business requires intelligent infrastructure support, which we struggled to find for years. Partnering with DDevOps to manage our servers was the ultimate solution. We are incredibly impressed with their deep expertise and near 24/7 support availability. We couldn\'t be happier with their services."',
    company: '— HOOJAN',
    author: 'Saad Chkail – CEO',
  },
  {
    text: '"In the rapidly evolving insurance landscape, quick technology adoption is essential. DDevOps has been instrumental in our digital transformation at TPL Insurance. They seamlessly bridged the gap between cutting-edge tech and our complex operational requirements. Their expertise ensured our infrastructure advancement was secure, scalable, and ready for the future. A pivotal strategic partner."',
    company: '— TPL Insurance',
    author: 'Imtiaz Ahmed – Chief Digital Officer',
  },
  {
    text: '"For our intense AI and ML development at PythonAnywhere, we required robust infrastructure. DDevOps stepped up with high-end Windows GPU machines that handled our computational needs flawlessly. Crucially, their responsive IT operations support during peak development cycles allowed us to focus entirely on innovation rather than managing hardware. A reliable partner for demanding workloads."',
    company: '— PythonAnywhere',
    author: 'Hammad Randhawa – Technopreneur',
  },
];

function TestimonialsCarousel() {
  return (
    <section id="Testimonials" style={{ margin: '7rem auto' }}>
      <div className="container px-3 position-relative">
        <img src={gradientCircle} loading="lazy" className="quote-bg-left" alt="Quote background" />
        <img src={gradientBlue} loading="lazy" className="quote-bg-right" alt="Quote background" />
        <div className="row testi-gradient justify-content-center text-center">
          <h1 className="top-line">
            Testimonials <br />
            <span style={{ color: '#00aaff' }}>Our Awesome Clients</span>
          </h1>
        </div>
      </div>

      <div className="container my-5">
        <div className="row align-items-center">
          {/* Left Text */}
          <div className="col-lg-6 col-md-12 mb-4 mb-lg-0" data-aos="fade-up">
            <h4 className="fs-2 fw-semibold text-start">
              Trusted by <span style={{ color: '#00aaff' }}>CTOs</span>. Verified by Uptime.
            </h4>
            <p className="text-muted mt-3" style={{ maxWidth: '90%' }}>
              Deployment velocity increased. Downtime eliminated. See what technical leaders say about partnering with <strong>DDevOps</strong>.
            </p>
          </div>

          {/* Right Carousel */}
          <div className="col-lg-6 col-md-12">
            <div id="testimonialCarousel" className="carousel slide testimonial-carousel"
              data-bs-ride="carousel" data-bs-interval="7000" data-bs-pause="false">
              <div className="carousel-inner testimonial-border pt-4">
                {testimonials.map((t, i) => (
                  <div className={`carousel-item ${i === 0 ? 'active' : ''}`} key={i}>
                    <div className="testimonial-item">
                      <p className="testimonial-text">{t.text}</p>
                      <h6 className="testimonial-company">{t.company}</h6>
                      <h6 className="testimonial-author">{t.author}</h6>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TestimonialsCarousel;
